<template>
  <div
    class="match"
    :class="`match-sport-color-${match.idSport}`">
    <match-header
      :id-match="match.id"
      :id-sport="match.idSport"
      :id-display="match.idDisplay"
      :match-status="match.status"
    />
    <div
      v-if="!visualizationDisabled"
      class="grid-top">
      <stream-player
        :key="match.id"
        :id-match="match.id"
        :index="coloredId ? 1 : 0"
        v-if="match.hasStream && !scoutDisplaySelected"
      />
      <scout
        :id-match="match.id"
        :index="coloredId ? 1 : 0"
        v-if="scoutDisplaySelected || (match.hasScout && !match.hasStream)"
      />
      <error-message
        :message="mediaErrorMessage"
        :class="{ middle: !match.hasScout }"
        v-if="mediaErrorMessage"
      />
    </div>
    <div :class="['grid-bottom', {expanded: visualizationDisabled}]">
      <match-bets
        :id-match="match.id"
        :id-sport="match.idSport"
        :match-betting-status="match.bettingStatus"
        :match-status-period="match.status.period"
        :colored-id="coloredId"
        :visualization-disabled="visualizationDisabled"
      />
    </div>
  </div>
</template>

<script>
import ErrorMessage from '@/components/common/error-message/ErrorMessage.vue';
import Scout from '@/components/common/scout/Scout.vue';
import StreamPlayer from '@/components/common/stream-player/StreamPlayer.vue';
import MatchHeader from './MatchHeader.vue';
import MatchBets from './MatchBets.vue';

export default {
  name: 'Match',
  components: {
    MatchHeader,
    MatchBets,
    ErrorMessage,
    Scout,
    StreamPlayer,
  },
  props: {
    idMatch: {
      required: true,
      type: Number,
    },
    coloredId: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    match() {
      return this.$store.getters.getMatch(this.idMatch);
    },
    mediaErrorMessage() {
      return this.match.mediaErrorMessage;
    },
    visualizationDisabled() {
      return this.$store.getters.visualizationDisabled(this.idMatch)
        || (!this.match.hasScout && !this.match.hasStream);
    },
    scoutDisplaySelected() {
      return this.$store.getters.scoutDisplaySelected(this.idMatch);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match {
  overflow: hidden;
}

.grid-top {
  position: relative;
  float: left;
  width: 100%;
  height: 50vh;
}

.grid-bottom {
  float: left;
  width: 100%;
  height: 40vh;
  &.expanded {
    height: 90vh;
  }
}
</style>
